export default "__VITE_ASSET__BmNvyD6t__"